// src/components/_v3/touristic-site/SiteHeader.jsx
import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {Wrap, BtnBrand} from '../../../_ui/_v3/primitives';
import LanguageSelector from '../../../_ui/_v2/components/LanguageSelector';
import logo from 'assets/img/logo/Logo_henri-side.svg';

const HeaderStyled = styled.header`
  position: sticky;
  top: 0;
  z-index: 60;
  background: ${props => props.theme.colors.paperCard};
  border-bottom: 1px solid ${props => props.theme.colors.line};

  ${Wrap} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.2rem;
    height: 64px;
  }
`;

const LogoStyled = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  flex: none;
  img { height: 26px; width: auto; }
`;

const NavLinksStyled = styled.nav`
  display: flex;
  gap: 1.3rem;
  font-size: .88rem;
  font-weight: 600;
  color: ${props => props.theme.colors.inkSoft};
  a { text-decoration: none; }
  a:hover { color: ${props => props.theme.colors.ink}; }

  @media (max-width: 820px) {
    display: none;
  }
`;

const RightGroupStyled = styled.div`
  display: flex;
  align-items: center;
  gap: .8rem;
  flex: none;
`;

/* Wrapper to normalise LanguageSelector size/colour in the light header context */
const LangSelectorWrap = styled.div`
  font-size: .85rem;
`;

const SiteHeader = () => {
  const {t} = useTranslation(['touristic-site']);
  return (
    <HeaderStyled>
      <Wrap>
        <LogoStyled href="https://henritrip.fr/" aria-label="Henri Trip — accueil">
          <img src={logo} alt="Henri Trip" />
        </LogoStyled>
        <NavLinksStyled>
          <a href="https://www.henritrip.fr/app-mobile">{t('v3.header.app')}</a>
          <a href="https://www.henritrip.fr/henri-trip">{t('v3.header.about')}</a>
          <a href="https://www.henritrip.fr/outils-voyage">{t('v3.header.tools')}</a>
        </NavLinksStyled>
        <RightGroupStyled>
          <LangSelectorWrap>
            <LanguageSelector />
          </LangSelectorWrap>
          <BtnBrand href="https://www.henritrip.fr/abonnement-henri-trip">{t('v3.header.subscribe')}</BtnBrand>
        </RightGroupStyled>
      </Wrap>
    </HeaderStyled>
  );
};

export default SiteHeader;
